'use client'
import Link from 'next/link'
import { signOut } from 'next-auth/react'
import { Button } from './Button'
import Container from './Container'

export default function Unauthorized() {
  return (
    <Container className="flex items-center justify-center">
      <div className="max-w-[500px] py-40 text-center">
        <h2 className="text-3xl">Keine Berechtigung</h2>
        <p className="py-10">
          Du hast keine Berechtigung diese Seite zu sehen.
          <br />
          <br />
          Logge dich mit einem anderen Konto ein oder wende dich an den Support.
          <br />
          <br />
          E-Mail:{' '}
          <Link href="mailto:tbf@support.farbenmeer.de" className="button-text">
            support@collab.center
          </Link>
        </p>
        <Button variant="cta" onClick={() => signOut()}>
          Ausloggen
        </Button>
      </div>
    </Container>
  )
}
